
import { Vue } from 'nuxt-property-decorator'
import Component from 'nuxt-class-component'

@Component
export default class EmptyLayout extends Vue {}
